import { render, staticRenderFns } from "./CreditsString.vue?vue&type=template&id=1d009882&"
import script from "./CreditsString.vue?vue&type=script&lang=js&"
export * from "./CreditsString.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports